import React from "react";
import {Modal} from "react-native";
import type {LegalDocumentType} from "../types";
import Div from "../lib/Div";

type Props = { documentType: LegalDocumentType | null, onBack: () => void };

const getLegalScreen = (documentType: LegalDocumentType) => {
  switch (documentType) {
    case 'TermsAndConditions':
      return require('../screens/TermsAndConditionsScreen').default;
    case 'PrivacyPolicy':
      return require('../screens/PrivacyPolicyScreen').default;
    case 'ResponsibleGaming':
      return require('../screens/Common/Responsible-Gaming').default;
    case 'SelfExclusion':
      return require('../screens/SelfExclusionScreen').default;
    case 'Promotions':
      return require('../screens/PromotionsScreen').default;
  }
};

const LegalDocumentModal = ({documentType, onBack}: Props) => {
  if (!documentType) return null;

  const Screen = getLegalScreen(documentType);

  return (
    <Modal visible animationType="fade" onRequestClose={onBack}>
      <Div flex={1} bg="#131314">
        <Screen onExit={onBack}/>
      </Div>
    </Modal>
  );
};

export default LegalDocumentModal;
